// extracted by mini-css-extract-plugin
export var printerCard = "_a5-1";
export var printerCardConfigured = "_a5-2";
export var printerCardError = "_a5-3";
export var printerCardsContainer = "_a5-0";
export var printerIcon = "_a5-8";
export var printerIconConfigured = "_a5-5";
export var printerIconContainer = "_a5-4";
export var printerIconError = "_a5-6";
export var printerIconUnconfigured = "_a5-7";